import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import type {
  AskPredefinedTemplate,
  AskTemplate,
  CreateAskTemplate,
  UpdateAskTemplate,
} from '@core/ask-hr-templates-types';

import { injectTellentAskHttp } from '../ask-http.service';

@Injectable({ providedIn: 'root' })
export class TemplatesHttpService {
  private readonly askHttpApi = injectTellentAskHttp();

  public fetchPredefinedTemplates(): Observable<AskPredefinedTemplate[]> {
    return this.askHttpApi.get('/templates/predefined').pipe(map(res => res.data));
  }

  public createTemplate(template: CreateAskTemplate): Observable<AskTemplate> {
    return this.askHttpApi.post('/templates', null, template).pipe(map(res => res.data));
  }

  public fetchOne(id: AskTemplate['id']): Observable<AskTemplate> {
    return this.askHttpApi.get(`/templates/${id}`).pipe(map(res => res.data));
  }

  public updateTemplate(template: UpdateAskTemplate): Observable<AskTemplate> {
    const { id: _, ...templateData } = template;
    return this.askHttpApi
      .patch(`/templates/${template.id}`, null, templateData)
      .pipe(map(res => res.data));
  }

  public deleteTemplate(id: AskTemplate['id']): Observable<{ success: true }> {
    return this.askHttpApi.delete(`/templates/${id}`);
  }
}
